export const userInfosMockData = {
  login: 'johnDoeIsNotAffraid',
  firstname: 'John',
  lastname: 'Doe',
  picture: './public/img/26115.jpg',
  showPicture: true
};



// WEBPACK FOOTER //
// ./src/app/models/userInfosMock.js